import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, useTheme } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { IncidentReport } from '../../components/incident/IncidentReport';
import { Incident } from '../../state/reduxRepositories/incident/incident.interface';
import { ViewIncidentStatusProps } from './viewIncident.interface';
import { Collapsible } from '../../components/collapsible/collapsible';
import { Banner } from '../../components/banner/banner';

interface SummaryProps {
  player?: string;
  incidentsById: Incident;
  incidentsByPlayer?: Incident[];
  isCoaches?: boolean;
  incidentStatus: ViewIncidentStatusProps | string;
}

export function Summary({
  player,
  incidentsById,
  isCoaches,
  incidentsByPlayer,
  incidentStatus,
}: SummaryProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Grid>
        <Grid container justifyContent="space-between">
          <Grid sx={{ m: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              {t('incident.INCIDENT_SUMMARY_STATUS_LABEL')}
            </Typography>
          </Grid>
          <Grid item display="flex" flexDirection="row" alignItems="center">
            {incidentStatus === 'waiting' && (
              <>
                <InfoIcon sx={{ fill: theme.palette.warning.main }} />
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ ml: 1 }}
                >
                  {t('incident.INCIDENT_SUMMARY_STATUS_AWAITING_CLEARANCE')}
                </Typography>
              </>
            )}
            {incidentStatus === 'cleared' && (
              <>
                <CheckCircleIcon sx={{ fill: theme.palette.success.main }} />
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ ml: 1 }}
                >
                  {t('incident.INCIDENT_SUMMARY_STATUS_DOCTOR_CLEARED')}
                </Typography>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Collapsible title={t('incident.INCIDENT_SUMMARY_WHAT_HAPPENED_TITLE')}>
        {incidentsById !== undefined ? (
          <IncidentReport
            isCoaches={isCoaches}
            player={player}
            incident={incidentsById}
          />
        ) : (
          <Banner
            severity="warning"
            elevation={2}
            title={t('incident.INCIDENT_SUMMARY_NOT_AVAILABLE')}
          />
        )}
      </Collapsible>

      {/* <div className={styles.symptomsContainer}>
            <Collapsible
              title={t('INCIDENT_SUMMARY_SYMPTOMS_CHECK_TITLE')}
              defaultValue
            >
              <ul className={styles.symptomsCheck}>
                <li>
                  {t('INCIDENT_SUMMARY_SYMPTOMS_CHECK_STEP', {
                    player,
                  })}
                </li>
                <li>
                  {t('INCIDENT_SUMMARY_SYMPTOMS_CHECK_TELEHEALTH', {
                    player,
                  })}
                </li>
              </ul>
              <div className={styles.performCheck}>
                <Button
                  color="primary"
                  variant="contained"
                  onPress={() => {}}
                  label={t('INCIDENT_SUMMARY_PERFORM_SYMPTOM_CHECK').toString()}
                  fullWidth
                />
              </div>
            </Collapsible>
          </div> */}
      {/* <div className={styles.timeline}>
            <Collapsible
              title={t('INCIDENT_SUMMARY_TIMELINE_TITLE')}
              defaultValue
            >
              <Timeline incidents={incidentsByPlayer} />
            </Collapsible>
          </div> */}
    </>
    //   )}
    // </>
  );
}
